import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children, roles }) => {
    const { isAuthenticated, hasRole } = useAuth();
    const location = useLocation();

    if (location.pathname === '/checkout' && location.state?.proceedAsGuest === true) {
        return children;
    }

    if (!isAuthenticated()) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (roles && !hasRole(roles)) {
        return <Navigate to="/" replace />;
    }

    return children;
}; 